var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"UserReviewBox"},[_c('StarRating',{attrs:{"value":_vm.rating * 20,"item-size":22,"read-only":""}}),_c('div',{staticClass:"UserReviewBox__description"},[_vm._v(_vm._s(_vm.description))]),_c('div',{staticClass:"UserReviewBox__author"},[_vm._v(_vm._s(_vm.author))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }